<template>
  <div>
    <!-- 搜索弹框 -->
    <el-dialog v-dialogDrag :visible.sync="vis"
               :title="$t('getapi[975]')"
               width="80%"
               :close-on-click-modal="false">
      <div>
        <table>
          <tr>
            <td style="width:80px"
                align="right">{{$t('getapi[2095]')}}</td>
            <td style="width:120px;">
              <el-input v-model="dataDetail.head.order_no"
                        type="text"
                        size="mini" :disabled="true"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[2097]')}}</td>
            <td style="width:120px">
              <el-select filterable
                         v-model="dataDetail.head.receive_type_id"
                         size="mini" :disabled="addoredit == 2">
                <el-option v-for="item in ArrayReceiveType"
                           :key="item.Code"
                           :label="item.Name"
                           :value="item.Code"></el-option>
              </el-select>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[2098]')}}</td>
            <td style="width:120px;">
              <el-input v-model="dataDetail.head.keep_account_No"
                        type="text"
                        size="mini" :disabled="true"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[1864]')}}</td>
            <td style="width:120px;">
              <!--<el-input v-model="dataDetail.head.Keep_Person"
                        type="text"
                        size="mini"></el-input>-->
              <routejump :urlNo="6">
              <el-input v-model="dataDetail.head.keep_person" type="text"
                        readonly
                        :disabled="addoredit == 2"
                        size="mini">
                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectEmployee(1)"></i>
              </el-input>
              </routejump>
            </td>
          </tr>
          <tr>
            <td style="width:80px"
                align="right">{{$t('getapi[1311]')}}</td>
            <td style="width:120px;">
              <el-input v-model="dataDetail.head.keep_account_person"
                        type="text"
                        size="mini" :disabled="true"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[135]')}}</td>
            <td style="width:120px;">
              <el-input v-model="dataDetail.head.keep_account_time"
                        type="text"
                        size="mini" :disabled="true"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[2099]')}}</td>
            <td style="width:120px;">
              <el-input v-model="dataDetail.head.receive_person"
                        type="text"
                        size="mini" :disabled="true"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[4470]')}}</td>
            <td style="width:120px;">
              <!--<el-input v-model="dataDetail.head.Regist_Person"
                        type="text"
                        size="mini"></el-input>-->
              <routejump :urlNo="6">
              <el-input v-model="dataDetail.head.regist_person" type="text"
                        readonly
                        :disabled="addoredit == 2"
                        size="mini">
                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectEmployee(2)"></i>
              </el-input>
              </routejump>
            </td>
          </tr>
          <tr>
            <td style="width:80px"
                align="right">{{$t('getapi[2100]')}}</td>
            <td style="width:120px;">
              <el-input v-model="dataDetail.head.receive_time"
                        type="text"
                        size="mini" :disabled="true"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[1861]')}}</td>
            <td style="width:120px;">
              <el-input :value="expStatus(dataDetail.head.order_status)"
                        type="text"
                        size="mini" :disabled="true"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[1862]')}}</td>
            <td style="width:120px;">
              <!--{{expFinanceStatus(dataDetail.head.Finance_Status)}}-->
              <el-input :value="expFinanceStatus(dataDetail.head.finance_status)"
                        type="text"
                        size="mini" :disabled="true"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[1863]')}}</td>
            <td style="width:120px;">
              <el-input v-model="dataDetail.head.totalsum"
                        type="text"
                        size="mini" :disabled="true"></el-input>
            </td>
          </tr>
          <tr>
            <td style="width:80px"
                align="right">{{$t('getapi[1857]')}}</td>
            <td style="width:120px;">
              <el-input v-model="dataDetail.head.finance_date"
                        type="text"
                        size="mini" :disabled="true"></el-input>
            </td>
            <td style="width:80px"
                align="right">{{$t('getapi[2203]')}}</td>
            <td style="width:120px;">
              <el-input v-model="dataDetail.head.base_order_no"
                        type="text"
                        size="mini" :disabled="true"></el-input>
            </td>
            <td style="width:80px;"></td>
            <td style="width:120px;">
            </td>
            <td style="width:80px"
                class="alignment-right">
              {{$t('getapi[2096]')}}
              <el-checkbox  :value="expNegativeStatus(dataDetail.head.negative_flag)" :disabled="true"></el-checkbox>
            </td>
          </tr>
        </table>
        <div>
          <el-button type="primary"
                     size="mini"
                     @click="addMaterials('')" :disabled="addoredit == 2">{{$t('getapi[6092]')}}</el-button>
          <el-button type="primary"
                     size="mini"
                     @click="deleteLine" :disabled="addoredit == 2">{{$t('getapi[1522]')}}</el-button>
          <el-button type="primary"
                     size="mini"
                     @click="excute">{{$t('getapi[2105]')}}</el-button>
          <el-button type="primary"
                     size="mini"
                     @click="finance">{{$t('getapi[2106]')}}</el-button>
          <el-button type="primary"
                     size="mini"
                     @click="negative">{{$t('getapi[2107]')}}</el-button>
        </div>
        <el-table :data="dataDetail.line"
                  height="300"
                  border
                  size="mini"
                  @selection-change="handleSelectionChange"
                  style="width: 100%; margin-top:5px">
          <el-table-column type="selection"></el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="line_no"
                           :label="$t('getapi[1425]')"
                           align="right">
            <template scope="scope">
              <el-input size="mini" v-model="scope.row.line_no"></el-input>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="part_code"
                           :label="$t('getapi[112]')">
            <template scope="scope">
              <!--<el-input size="mini" v-model="scope.row.part_code"></el-input>-->
              <el-input v-model="scope.row.part_code" type="text"
                        readonly
                        size="mini">
                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="addMaterials(scope)"></i>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="part_name"
                           :label="$t('getapi[116]')"></el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="part_version"
                           :label="$t('getapi[149]')"></el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="batch_no"
                           :label="$t('getapi[1763]')">
            <template scope="scope">
              <el-input size="mini" v-model="scope.row.batch_no" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="sequence_no"
                           :label="$t('getapi[1764]')">
            <template scope="scope">
              <el-input size="mini" v-model="scope.row.sequence_no" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="receive_qty"
                           :label="$t('getapi[1628]')">
            <template scope="scope">
              <el-input size="mini" v-model="scope.row.receive_qty" @change="sum(scope)"></el-input>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="unit_price"
                           :label="$t('getapi[1410]')"></el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="line_net_total_amount"
                           :label="$t('getapi[2102]')"></el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="measureunit"
                           :label="$t('getapi[888]')"></el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="model"
                           :label="$t('getapi[124]')"></el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="specification"
                           :label="$t('getapi[125]')"></el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="cargo_position"
                           :label="$t('getapi[1957]')">
            <template scope="scope">
              <!--<el-input size="mini" v-model="scope.row.cargo_position"></el-input>-->
              <el-input v-model="scope.row.cargo_position" type="text"
                        readonly
                        size="mini">
                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="getInvCargo(scope)"></i>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
                           prop="remark"
                           :label="$t('getapi[143]')">
            <template scope="scope">
              <el-input size="mini" v-model="scope.row.remark"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button @click="vis = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="confirm">{{$t('getapi[937]')}}</el-button>
			</span>
    </el-dialog>
    <!--人员 -->
    <employee :isVisible="employeeVisible" @getemployee="getemployee" ref="inputemp"></employee>

    <!-- 新增物料弹框 -->
    <OM :isVisible="materialsVisible" @addmaterials="addmaterials" ref="addmaterials"></OM>

    <!-- 货位 -->
    <invcargo :isVisible="cargoVisible" @getinvcargo="getinvcargo" ref="invcargo"></invcargo>
  </div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
  name: 'InvInManager',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      userData:[],
      user: "",
      dataDetail: {
        head: {},
        line: []
      }, // 数据详情
      vis: this.isVisible, // 是否显示弹窗，
      ArrayReceiveType: [], // 入库类型
      // ArrayTransMode: [], // 运输方式
      employeeVisible: false, // 是否显示人员列表
      getEmployeeType: "", // 当前是获取什么类型人员
      materialsVisible: false,
      dataChecked: [],
      addoredit: -1,
      rowindex: -1,
      cargoVisible: false,
    }
  },
  mounted: function () {
    let that = this
    that.vis = that.isVisible;
    that.ArrayReceiveType = Array.methods.getReceieveType();
    that.userData =JSON.parse(sessionStorage.getItem('userData'));
    that.user = that.userData.username
  },
  methods: {

    clearInput (e, data) {
      let that = this
      that.vis = e;
      if (data == '') {
        that.addoredit = 1
        that.dataDetail.head = {
              order_no:"",
              order_status:0,
              receive_type_id:"",
              keep_account_no:"",
              receive_person:"",
              receive_time:"",
              keep_account_person:"",
              keep_account_time:"",
              remark:"",
              finance_status:"",
              finance_date:"",
              keep_person:that.user,
              regist_person:that.user,
              negative_flag:false,
              totalsum:0,
              base_order_no:"",
              concurrent_time:""
            };
          that.dataDetail.line = []
      } else {
        that.addoredit = 2
        that.getDetail(data);
      }
    },
    getDetail (data) {
      let that = this
      let parm = data
      parm.LangType = that.$processdata.getLang()
      that.$http.urlpost('/Inv/MaterialIn/InvReceieveDetail', parm, function (res) {
        if (res.Success == 1) {
          that.dataDetail.head = res.DataContent.head[0]
          that.dataDetail.line = res.DataContent.line
        }
      });
    },
    confirm(){
        let that = this
        /*let arr = [];
        for(let i = 0;i<that.dataDetail.line.length;i++){
            arr = [...arr,{
                Exclusively_Id:that.dataDetail.line[i].Exclusively_Id,
                Relation_Order_No:that.dataDetail.line[i].Relation_Order_No,
                line_no:that.dataDetail.line[i].line_no,
                batch_No:that.dataDetail.line[i].Batch_No,
                sequence_no:that.dataDetail.line[i].Sequence_No,
                part_code:that.dataDetail.line[i].Part_code,
                part_name:that.dataDetail.line[i].Part_name,
                part_version:that.dataDetail.line[i].Part_version,
                model:that.dataDetail.line[i].Model,
                specification:that.dataDetail.line[i].Specification,
                receive_qty:that.dataDetail.line[i].receive_qty,
                MeasureUnit:that.dataDetail.line[i].Measureunit,
                receive_price:"",
                cargo_position:"",
                workproc_ID:"",
                line_status:"",
                Assist_MeasureUnit:"",
                Assist_Receive_Qty:"",
                remark:that.dataDetail.line[i].remark,
                Line_Net_Total_Amount:that.dataDetail.line[i].Line_Net_Total_Amount,
                Unit_Price:that.dataDetail.line[i].Unit_Price
            }]
        }
        let parm = {
            head: {
                Order_No:that.dataDetail.head.Order_No,
                Order_Status:that.dataDetail.head.Order_Status,
                receive_type_ID:that.dataDetail.head.Receive_type,
                keep_account_No:that.dataDetail.head.keep_account_No,
                receive_person:that.dataDetail.head.Receive_person,
                receive_time:that.dataDetail.head.Receive_time,
                keep_account_person:that.dataDetail.head.keep_account_person,
                Keep_account_time:that.dataDetail.head.Keep_account_time,
                remark:that.dataDetail.head.Remark,
                Finance_Status:that.dataDetail.head.Finance_Status,
                Finance_Date:that.dataDetail.head.Finance_Date,
                Keep_Person:that.dataDetail.head.Keep_Person,
                Regist_Person:that.dataDetail.head.Regist_Person,
                negative_flag:that.dataDetail.head.negative_flag,
                base_order_no:"",
                ConCurrent_Time:""
            },
            line: arr
        }*/
        let parm = {
            head: that.dataDetail.head,
            line: that.dataDetail.line,
            LangType: that.$processdata.getLang(),
        }
        that.$http.urlpost('/Inv/MaterialIn/InvReceieveSave', parm, function (res) {
            if (res.Success == 1) {
                that.$message.success(that.$processdata.explainCallbackMsg(Common.SuccessMsg));
                let parm = {
                    Code: res.UniqueNum,
                    IID: "",
                    Name: "",
                    Status: ""
                }
                that.getDetail(parm)
            }
        });
    },
    selectEmployee(type){
      let that = this
      that.employeeVisible = true
      that.getEmployeeType = type
      this.$refs.inputemp.clearInput(that.employeeVisible, false, 3);
    },
    // 获取
    getemployee(data) {
        let that = this
        if(that.getEmployeeType == 1){
            that.dataDetail.head.keep_Person = data.name;
        } else if (that.getEmployeeType == 2){
            that.dataDetail.head.regist_Person = data.name
        }
    },
    addMaterials(row) {
      let that = this
      that.rowindex = row.$index;
      that.materialsVisible = true
      that.$refs.addmaterials.clearInput(that.materialsVisible, false, 6);
    },
    addmaterials(data) {
        let that = this
        if(that.rowindex < that.dataDetail.line.length &&  that.rowindex != -1){
            that.dataDetail.line[that.rowindex].exclusively_id=data.exclusively_id;
            that.dataDetail.line[that.rowindex].relation_order_no="";
            that.dataDetail.line[that.rowindex].line_no=that.dataDetail.line.length + 1;
            that.dataDetail.line[that.rowindex].batch_no="*";
            that.dataDetail.line[that.rowindex].sequence_no="*";
            that.dataDetail.line[that.rowindex].part_code=data.part_code;
            that.dataDetail.line[that.rowindex].part_name=data.part_name;
            that.dataDetail.line[that.rowindex].part_version=data.part_version;
            that.dataDetail.line[that.rowindex].model=data.part_model;
            that.dataDetail.line[that.rowindex].specification=data.part_spec;
            that.dataDetail.line[that.rowindex].receive_qty=0;
            that.dataDetail.line[that.rowindex].measureunit=data.part_master_unit;
            that.dataDetail.line[that.rowindex].receive_price="";
            that.dataDetail.line[that.rowindex].cargo_position=data.cargoposition_code;
            that.dataDetail.line[that.rowindex].workproc_id="";
            that.dataDetail.line[that.rowindex].line_status="";
            that.dataDetail.line[that.rowindex].assist_measureunit=data.part_assist_unit;
            that.dataDetail.line[that.rowindex].assist_receive_qty=0;
            that.dataDetail.line[that.rowindex].remark="";
            that.dataDetail.line[that.rowindex].line_net_total_amount=0;
            that.dataDetail.line[that.rowindex].unit_price=data.inv_cost;
        } else {
            that.dataDetail.line = [...that.dataDetail.line,{
                exclusively_id:data.exclusively_id,
                relation_order_no:"",
                line_no:that.dataDetail.line.length + 1,
                batch_no:"*",
                sequence_no:"*",
                part_code:data.part_code,
                part_name:data.part_name,
                part_version:data.part_version,
                model:data.part_model,
                specification:data.part_spec,
                receive_qty:0,
                measureunit:data.part_master_unit,
                receive_price:"",
                cargo_position:data.cargoposition_code,
                workproc_id:"",
                line_status:"",
                assist_measureunit:data.part_assist_unit,
                assist_receive_qty:0,
                remark:"",
                line_net_total_amount:0,
                unit_price:data.inv_cost,
            }]
        }
    },
      getInvCargo(row) {
        let that = this
        that.rowindex = row.$index;
        that.cargoVisible = true
        let parm = {
            negative_flag: that.dataDetail.head.negative_flag,
            part_code: row.row.part_code,
            part_version: row.row.part_version,
            batch_no: row.row.batch_no,
            sequence_no: row.row.sequence_no
        }
        that.$refs.invcargo.clearInput(that.cargoVisible, parm);
    },
    //获取货位信息
    getinvcargo(data) {
        let that = this;
        that.dataDetail.line[that.rowindex].cargo_position = data.cargoposition_code
    },
    excute(){
        let that = this
        let parm = that.dataDetail
        parm.LangType = that.$processdata.getLang()
        that.$http.urlpost('/Inv/MaterialIn/InvReceieveExcute', parm, function (res) {
            if (res.Success == 1) {
                that.$message.success(that.$processdata.explainCallbackMsg(Common.SuccessMsg));
            }
        });
    },
    finance() {
      let that = this
      let parm = that.dataDetail.head
      that.$http.urlpost('/Inv/MaterialIn/UpdateFinanceStatus', parm, function (res) {
          if (res.Success == 1) {
              that.$message.success(that.$processdata.explainCallbackMsg(Common.SuccessMsg));
          }
      });

    },
    negative() {
      let that = this
      let parm = that.dataDetail.head
      that.$http.urlpost('/Inv/MaterialIn/CreateNegativeOrder', parm, function (res) {
          if (res.Success == 1) {
              that.$message.success(that.$processdata.explainCallbackMsg(Common.SuccessMsg));
          }
      });
    },
    handleSelectionChange(val) {
        let that = this;
        for (let i = 0; i < val.length; i++) {
            that.dataChecked.push(val[i].exclusively_id);
        }
    },
    deleteLine(){
        let that = this
        let arr = that.dataDetail.line.filter(item => {
            return that.dataChecked.every(item2 => {
                return item.exclusively_id != item2
            })
        })
        that.dataDetail.line = arr;
    },
    expNegativeStatus(val){
      if(val==1)return true;
      else return false;
    },
    expStatus(val){
        if(val == 0){
            return '生成'
        } else if (val == 1){
            return '审核'
        } else if(val == 2){
            return '作废'
        } else {
            return ''
        }
    },
    expFinanceStatus(val){
        if(val == 0){
            return '审核'
        } else if (val == 1){
            return '记账'
        } else if (val == 2){
            return '月结'
        } else {
            return ''
        }
    },
    sum(row){
        let that = this
        that.rowindex = row.$index;
        that.dataDetail.line[that.rowindex].receive_qty = parseInt(that.dataDetail.line[that.rowindex].receive_qty)
        that.dataDetail.line[that.rowindex].line_net_total_amount = that.dataDetail.line[that.rowindex].unit_price * that.dataDetail.line[that.rowindex].receive_qty
    }
  }
};
</script>

<style scoped lang="less">
table {
  border-collapse: separate;
  border-spacing: 0px 5px;
  tr {
    line-height: 28px;
    height: 28px;
    td {
      padding-left: 3px;
      white-space: pre;
    }
  }
}
.el-input__inner {
  line-height: 28px;
  height: 28px;
}
</style>
